import { useEffect } from "react";

export const useTabName = (name?: string | null) => {
  useEffect(() => {
    const originalName = document.title;
    document.title = name == null ? "ScrapChef" : `${name} - ScrapChef`;
    return () => {
      document.title = originalName;
    };
  }, [name]);
};
